import React from 'react'
import { useSelector } from 'react-redux'
import { Grid } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import DOMPurify from 'dompurify'

import { getMembershipIsPortalEmbed } from '../../../store/duck/wellnessPlans'

const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: theme.spacing(0, 2),
      overflowY: 'auto',
      maxHeight: ({ isPortalEmbed }: { isPortalEmbed: boolean }) =>
        `calc(var(--app-height) - ${isPortalEmbed ? 232 : 405}px)`,
      fontSize: '1.2rem',
    },
  }),
  { name: 'GlobalTermsAndConditions' },
)

const GlobalTermsAndConditions = ({
  onScroll,
  termsAndConditions,
}: {
  readonly onScroll: (event: React.UIEvent<HTMLElement>) => void
  readonly termsAndConditions: string
}) => {
  const isPortalEmbed = useSelector(getMembershipIsPortalEmbed)
  const classes = useStyles({ isPortalEmbed })

  return (
    <Grid
      container
      className={classes.root}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(termsAndConditions),
      }}
      data-testid="terms-and-conditions-container"
      onScroll={onScroll}
    />
  )
}

export default GlobalTermsAndConditions
